module.exports = __webpack_public_path__ + "img/page-not-found-logo.f98b7e5c.svg";